import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import styles from 'pages/events/1st-dfa-annual-conference/AnnualConference.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Events/AnnualConference/components/SectionHeader'));
const SectionArticles = dynamic(() => import('sections/Events/AnnualConference/components/SectionArticles'));

export default function AnnualConference() {
  return (
    <div className={cn('annual-conference')}>
      <SectionHeader/>
      <SectionArticles/>
    </div>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      path: '/events/1st-dfa-annual-conference',
      title: 'Join the 1st DFA Annual Conference | DF Alliance',
      description:
        'Explore DF Alliance\'s 1st Annual Conference event and join industry leaders for a comprehensive discussion on global freight trends, innovations, and networking.',
    },
  };
};

AnnualConference.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
